import React, { ReactElement } from 'react'

export const OverflowedIcon = (): ReactElement => (
    <svg viewBox='0 0 100 100'>
        <defs>
            <clipPath id='a'>
                <path d='m18.512 20h62.977v60h-62.977z' />
            </clipPath>
        </defs>
        <g clipPath='url(#a)'>
            <path
                d='m63.664 38.758c1.4453 0 2.9297-0.003906 4.4023-0.003906 7.5-0.007812 13.441 7.2734 13.422 15.863-0.023437 9.5039-5.9336 15.625-13.328 15.625h-4.6641v8.9961l-13.496-13.496 13.496-13.492v8.9961h4.6641c2.3711 0 4.3359-2.0352 4.3477-6.6484 0.007813-3.9648-2.3438-6.8477-4.4297-6.8477-2.5703 0.003906-5.1758 0.003906-7.543 0h-1.2539-36.293c-2.4727 0-4.4766-1.9961-4.4766-4.4961 0-2.4844 2-4.5 4.4766-4.5h40.527c0.050781 0 0.097656 0 0.14844 0.003906zm-45.152-13.5c0-2.4844 2.0234-4.4961 4.5273-4.4961h53.918c2.5039 0 4.5312 1.9961 4.5312 4.4961 0 2.4844-2.0234 4.5-4.5312 4.5h-53.918c-2.5 0-4.5273-1.9961-4.5273-4.5zm0 40.484c0-2.4844 2.0273-4.4961 4.457-4.4961h18.074c2.4648 0 4.457 1.9961 4.457 4.4961 0 2.4844-2.0273 4.5-4.457 4.5h-18.074c-2.4609 0-4.457-1.9961-4.457-4.5z'
                fillRule='evenodd'
            />
        </g>
    </svg>
)
